import { stringify, parse } from 'qs'

export const truncate = (string, length) => (
  string.length > length ? `${string.substring(0, length)} ...` : string
)

export const formatJson = (json) => {
  try {
    return JSON.stringify(JSON.parse(json), null, 2)
  } catch (e) {
    return json
  }
}

export const stringifyQuery = (query) => stringify(query, {
  arrayFormat: 'brackets',
  encodeValuesOnly: true,
})

export const parsedQuery = (queryString) => {
  return parse(queryString, { ignoreQueryPrefix: true, arrayFormat: 'brackets' })
}

export function validateMac (value) {
  let valid = false
  if (!value) {
    valid = true
  } else {
    const validationRegexp = /^(([A-Fa-f0-9]{2}[-]){5}[A-Fa-f0-9]{2}[;]+?|[\u00A0])+?|(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[;]+?|[\u00A0])+?|([0-9a-f]{4}.[0-9a-f]{4}.[0-9a-f]{4}[;]+?|[\u00A0]+?)|(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[\u00A0]?)|(([A-Fa-f0-9]{2}[-]){5}[A-Fa-f0-9]{2}[\u00A0]?)|([0-9a-f]{4}.[0-9a-f]{4}.[0-9a-f]{4}[\u00A0]?)/g
    let matchLength = 0
    let item
    while ((item = validationRegexp.exec(value)) !== null) {
      matchLength += item[0].length
    }
    valid = (matchLength === value.replace(/\s+/g, '').length) || value === 'NA'
  }
  return valid
}

export function uniqueId () {
  return '_' + Math.random().toString(36).substr(2, 9)
}

export function translateQueryPeriod (t, period) {
  let newPeriod = period
  if (period) {
    const translateUnit = {
      'min': t('common.periodMin'),
      'h': t('common.periodHour'),
      'day': t('common.periodDay'),
    }

    const [value, unit] = period.split(' ')
    const translatedUnit = translateUnit[unit]

    if (translatedUnit) {
      newPeriod = value + ' ' + translateUnit[unit]
    }
  }
  return newPeriod
}

export function convertFileSize (size) {
  let result
  if (size < 1024) {
    result = size + ' B'
  } else if (size < 1048576) {
    result = (size / 1024).toFixed(1) + ' KB'
  } else {
    result = (size / 1048576).toFixed(1) + ' MB'
  }
  return result
}

export function capitalizeFirstLetter (value) {
  if (!value) {
    return value
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function isUrlValid (url) {
  try {
    return new URL(url)
  } catch (e) {
    return false
  }
}
